<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    min-width="0"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <text-input
        v-model="dateRangeText"
        :label="label"
        class="date-input"
        prepend-icon="event"
        hide-details
        readonly
        v-on="on"
      />
    </template>
    <v-date-picker
      ref="picker"
      :max="new Date().toISOString().substr(0, 10)"
      :value="value"
      min="2020-06-01"
      range
      @input="onInput"
      @change="onChange"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import TextInput from '@/components/forms/text-input'

export default {
  name: 'DateRangePicker',
  components: {
    TextInput,
  },
  props: {
    label: {
      type: String,
      default: 'Date Range',
    },
    value: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    dateRangeText() {
      return this.value.join(' ~ ')
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
    onChange(value) {
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.date-input {
  min-width: 200px;
}
</style>
